import {useCallback, useMemo, useState} from "react";
import {columns as columnTable} from "../Columns";
import {ResizableTitle} from "./ResizableTitle";
import CommonList from "../../../../../common/list";

export const TableConfigKeyword = (props) => {
    const {dataSource} = props
    const [columns, setColumns] = useState(columnTable);

    const data = useMemo(() => dataSource, [dataSource]);

    const handleResize = useCallback(
        (index) => (e, { size }) => {
            setColumns((prevColumns) => {
                const nextColumns = [...prevColumns];
                nextColumns[index] = {
                    ...nextColumns[index],
                    width: size.width,
                };
                return nextColumns;
            });
        },
        []
    );

    const cols = useMemo(() =>
            columns.map((col, index) => ({
                ...col,
                onHeaderCell: (column) => ({
                    width: column.width,
                    onResize: handleResize(index),
                }),
            })),
        [columns, handleResize]
    );

    return (
        <CommonList
            {...props}
            components={{ header: { cell: ResizableTitle } }}
            columns={cols}
            dataSource={data}
        />

    );
};